import typeCheck from 'common/util/typeCheck';

import { SR_API_ACTION_GET_APARTMENT_BY_ID } from 'api/actionTypes';

export default async function getById({ state, apiClient }, { apartmentId, forceRefresh }) {
  typeCheck('apartmentId::Number', apartmentId);

  const apartmentStatePath = ['apartments', 'byId', apartmentId];
  if (state.get(apartmentStatePath) && !forceRefresh) {
    return state.get(apartmentStatePath);
  }

  return apiClient.postWithState({
    action: SR_API_ACTION_GET_APARTMENT_BY_ID,
    state: state,
    payload: {
      apartmentId: apartmentId,
    },
    onSuccess(apartment) {
      if (apartment) {
        state.set(apartmentStatePath, apartment);
      }
      return apartment;
    },
  });
}
